import React, { useEffect, useState } from 'react';
import { getHighlight } from '../../../../apis/Ambition';
import { PieChart } from 'react-minimal-pie-chart';
import { getBusinessTravelCarbon, getSupplyCarbon, getWasteCarbon } from '../../../../apis/Report/Report';
import { fontReport } from '../../../../apis/util';
import { PRINT_WIDTH } from '..';
import { useRef } from 'react';

export const Scope3 = ({ img, keyHighlight, number }) => {
  const [text, setText] = useState();
  const [travelCarbon, setTravelCarbon] = useState(0);
  const [wasteCarbon, setWasteCarbon] = useState(0);
  const [suppliesCarbon, setSuppliesCarbon] = useState(0);
  const [componentCarbon, setComponentCarbon] = useState(0);

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({
      key: keyHighlight,
      setValue: setText
    });
  };
  // const options = { chart: {
  //   events: {
  //     mounted: (chart) => {
  //       chart.windowResizeHandler();
  //     }
  //   }
  // },labels: ["Product Carbon", "Other Vehicle Carbon", "Aircon/refrigerant Carbon", "Industrial Gas Carbon", "Fire Suppresant Carbon"],
  //                   legend: {
  //                     fontSize:"20px",
  //                     markers:{
  //                       height:"20px",
  //                       width:"20px"
  //                     }
  //                   } };
  // const covidData =[vehicleCarbon, otherVehicleCarbon, airconCarbon,industrialCarbon,suppresantCarbon]
  useEffect(() => {
    getBusinessTravelCarbon({ total: travelCarbon, setTotal: setTravelCarbon });
    getWasteCarbon({ total: wasteCarbon, setTotal: setWasteCarbon });
    getSupplyCarbon({ total: suppliesCarbon, setTotal: setSuppliesCarbon });

  }, []);
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="ourenvironmentalaim" ref={ref}>
      <div className="ourenvironmentalaim__title">
        <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}><b>Scope</b> 3</h4>
        <img src={img} alt="" />
      </div>
      <div className="scopes__body">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.2/PRINT_WIDTH,"rem") }}>
          {text}
        </h5>

      </div>
      {/* <div>
              <h4>Travel Carbon: {travelCarbon}</h4>
              <h4>Waste Carbon: {wasteCarbon}</h4>
              <h4>Supplies Carbon: {suppliesCarbon}</h4>
              <h4>Commponents Carbon: {componentCarbon}</h4>
            </div> */}
      <div className="mx-auto mt-4 chart_chart_chart" style={{ width: "100%" }}>

        <div className="" style={{ padding: "20%", width: "70%" }}>


          <PieChart
            data={[
              { title: 'Vehicle Carbon', value: travelCarbon, color: '#c2a2ac' },
              { title: 'Two', value: wasteCarbon, color: '#ddd8db' },
              { title: 'Three', value: suppliesCarbon, color: '#bbd4d2' },
              { title: 'Three', value: componentCarbon, color: '#e2f15f' },
            ]}
            // label={({ dataEntry }) => dataEntry.title}
            // labelStyle={(index) => ({
            //   // fill: dataMock[index].color,
            //   fontSize: '5px',
            //   fontFamily: 'sans-serif',
            // })}
            // labelPosition={0}
            lineWidth={10} paddingAngle={5} />
        </div>
        <div className="" style={{ width: "30%" }}>
          <div className="d-flex mb-2"><div className='me-1' style={{ height: "20px", width: "30px", backgroundColor: "#c2a2ac" }}></div>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.1/PRINT_WIDTH,"rem") }}>Travel Carbon: {travelCarbon}</h5>
          </div>
          <div className="d-flex mb-2"><div className='me-1' style={{ height: "20px", width: "30px", backgroundColor: "#ddd8db" }}></div>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.1/PRINT_WIDTH,"rem") }}>Waste Carbon: {wasteCarbon}</h5>
          </div>
          <div className="d-flex mb-2"><div className='me-1' style={{ height: "20px", width: "30px", backgroundColor: "#bbd4d2" }}></div>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.1/PRINT_WIDTH,"rem") }}>Supplies Carbon: {suppliesCarbon}</h5>
          </div>
          <div className="d-flex mb-2"><div className='me-1' style={{ height: "20px", width: "30px", backgroundColor: "#e2f15f" }}></div>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.1/PRINT_WIDTH,"rem") }}>Commponents Carbon: {componentCarbon}</h5>
          </div>
        </div>
      </div>

    </div>
  );
};
